import { IFontSizeAutoAdjustBehavior, IFontSizeAutoAdjustBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTextDrawable } from "../../../beans/objects";

export class FontSizeAutoAdjustBehaviorTranslator {
  from(bean: IObjectBeanTextDrawable): IFontSizeAutoAdjustBehavior {
    return {
      isEnable: (bean["@auto-size"] === "1"),
    };
  }

  to(o: IFontSizeAutoAdjustBehaviorSpecifiable) {
    return {
      autoSize: o.fontSizeAutoAdjustBehavior.isEnable
        ? "1"
        : undefined,
    };
  }
}
